import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo, useState } from 'react';
import Slider from 'react-slick';
import { Box, Dialog } from '@mui/material';
import { Icon, Typography } from '@elements';
import { useEventSessions } from '@hooks/useEventSessions';
import Loader from '@components/loader/Loader';
import EventTicket from '@components/event-ticket';
import { Link } from 'react-router-dom';
import { StyledIconButton } from '@elements/icon-button/icon-button.styles';
import Close from '@images/close.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var formatDate = function formatDate(dateString) {
  var _parts$find, _parts$find2;
  var date = new Date(dateString);
  var formatter = new Intl.DateTimeFormat('ru', {
    month: 'long',
    year: '2-digit'
  });
  var parts = formatter.formatToParts(date);
  var month = capitalizeFirstLetter(((_parts$find = parts.find(function (part) {
    return part.type === 'month';
  })) === null || _parts$find === void 0 ? void 0 : _parts$find.value) || '');
  var year = ((_parts$find2 = parts.find(function (part) {
    return part.type === 'year';
  })) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value) || '';
  return "".concat(month, " \u2018").concat(year);
};
var formatMonthYearKey = function formatMonthYearKey(dateString) {
  var date = new Date(dateString);
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  return "".concat(year, "-").concat(month);
};
function SampleNextArrow(props) {
  var className = props.className,
    style = props.style,
    onClick = props.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: 'block',
      background: 'transparent'
    }),
    onClick: onClick
  });
}
function SamplePrevArrow(props) {
  var className = props.className,
    style = props.style,
    onClick = props.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: 'block',
      background: 'transparent'
    }),
    onClick: onClick
  });
}
var SeasonTicketEventsModal = function SeasonTicketEventsModal(_ref) {
  var _groupedEvents$active;
  var isOpen = _ref.isOpen,
    closeHandler = _ref.closeHandler,
    eventSessionId = _ref.eventSessionId,
    ticketUuid = _ref.ticketUuid;
  var _useEventSessions = useEventSessions(eventSessionId, ticketUuid, {
      enabled: isOpen
    }),
    data = _useEventSessions.data,
    isLoading = _useEventSessions.isLoading;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  var groupedEvents = useMemo(function () {
    if (!data) return {};
    var sortedData = _toConsumableArray(data).sort(function (a, b) {
      var dateA = a.dateBegin ? new Date(a.dateBegin).getTime() : 0;
      var dateB = b.dateBegin ? new Date(b.dateBegin).getTime() : 0;
      return dateA - dateB;
    });
    return sortedData.reduce(function (acc, event) {
      var _event$dateBegin, _event$dateBegin2;
      var monthYearKey = formatMonthYearKey((_event$dateBegin = event.dateBegin) !== null && _event$dateBegin !== void 0 ? _event$dateBegin : '');
      var label = formatDate((_event$dateBegin2 = event.dateBegin) !== null && _event$dateBegin2 !== void 0 ? _event$dateBegin2 : '');
      if (!acc[monthYearKey]) {
        acc[monthYearKey] = {
          label: label,
          events: []
        };
      }
      acc[monthYearKey].events.push(event);
      return acc;
    }, {});
  }, [data]);
  if (isLoading) return /*#__PURE__*/_jsx(Loader, {
    isShowLoader: true
  });
  var slides = Object.keys(groupedEvents).map(function (key) {
    return groupedEvents[key].label;
  });
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    afterChange: function afterChange(newIndex) {
      return setActiveSlide(newIndex);
    },
    variableWidth: true,
    adaptiveHeight: true,
    focusOnSelect: true,
    nextArrow: /*#__PURE__*/_jsx(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/_jsx(SamplePrevArrow, {})
  };
  var activeMonthYear = Object.keys(groupedEvents)[activeSlide];
  var eventsToShow = (((_groupedEvents$active = groupedEvents[activeMonthYear]) === null || _groupedEvents$active === void 0 ? void 0 : _groupedEvents$active.events) || []).sort(function (a, b) {
    var dateA = a.dateBegin ? new Date(a.dateBegin).getTime() : 0;
    var dateB = b.dateBegin ? new Date(b.dateBegin).getTime() : 0;
    return dateA - dateB;
  });
  return /*#__PURE__*/_jsxs(Dialog, {
    open: isOpen,
    keepMounted: true,
    onClose: closeHandler,
    "aria-describedby": "alert-dialog-slide-description",
    slotProps: {
      backdrop: {
        sx: {
          backdropFilter: 'blur(6px)'
        }
      }
    },
    PaperProps: {
      sx: {
        backgroundColor: 'transparent',
        overflow: 'visible',
        minWidth: {
          xs: 'auto',
          md: '414px'
        },
        maxWidth: {
          xs: '320px',
          md: '414px'
        },
        margin: '0px',
        alignSelf: 'normal',
        pt: '12px',
        boxShadow: 'none'
      }
    },
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'end'
      },
      children: /*#__PURE__*/_jsx(StyledIconButton, {
        onClick: closeHandler,
        children: /*#__PURE__*/_jsx(Icon, {
          src: Close,
          width: 28,
          height: 28
        })
      })
    }), /*#__PURE__*/_jsx(Typography, {
      color: "white",
      fontSize: 18,
      children: "\u0421\u043E\u0431\u044B\u0442\u0438\u044F"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        pt: '18px'
      },
      children: [/*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settings), {}, {
        children: slides.map(function (label) {
          return /*#__PURE__*/_jsx(Box, {
            sx: {
              px: {
                xs: '8px',
                md: '34px'
              },
              py: '6px'
            },
            children: /*#__PURE__*/_jsx(Typography, {
              color: "white",
              fontSize: 18,
              children: label
            })
          }, label);
        })
      })), /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          rowGap: '16px',
          pt: '24px',
          height: '80vh',
          overflowY: 'auto'
        },
        children: !eventsToShow.length ? /*#__PURE__*/_jsx(Typography, {
          color: "white",
          children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0438\u0306\u0434\u0435\u043D\u043E"
        }) : eventsToShow.map(function (event) {
          var _event$seats;
          event.seats = (_event$seats = event.seats) !== null && _event$seats !== void 0 ? _event$seats : [];
          return /*#__PURE__*/_jsx(Link, {
            style: {
              textDecoration: 'none'
            },
            to: "/tickets/events/".concat(event.id),
            children: /*#__PURE__*/_jsx(EventTicket, {
              event: event
            }, event.id)
          }, event.id);
        })
      })]
    })]
  });
};
export default SeasonTicketEventsModal;